// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 8462) return "static/chunks/8462-2ff747fcf07004aa.js";
	if (chunkId === 6545) return "static/chunks/6545-fe441b268d9bc850.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"6851":"79ff2c8e","8950":"01db7e4b"}[chunkId] || chunkId) + "." + {"530":"381137319a1a66a3","1558":"5589db9ec193d5b3","1790":"ee9511478d2dbd27","1956":"1604385122b67d46","2856":"41a90ca8b70e70db","4593":"07b5b7f660a5add4","5972":"ed9af93ed312b1e7","6851":"230a6f6e7defe9ec","6974":"96b8eb40ee90faf8","8950":"a16531a42c576a5e"}[chunkId] + ".js";
};